<template>
    <div>Device Management</div>
</template>